module.exports = "/dashboard/manage/users/edit-personal-62c853.html";